// for creating temporary digital spaces
// https://mccglc.atlassian.net/l/c/xNXsd6YW for DOCS
// docs probably are not in date enough to be useful

const actions = {
  async createSpaceHandler({commit, dispatch}, data) {
    let res = await dispatch('api/nav/createRoom', data);

    if(res.success) {
      let data = res.success
      commit('routing/BLOCK_GET_ROOM_DATA', true)
      dispatch('routing/goToRoom',data.id)
      await dispatch('enterSpaceCallback', res)
      dispatch('handleOpenRoomLink', data)
      dispatch('analytics/createRoom', data)
    } else {
      dispatch('popups/nav/errorCreatingRoom')
    }
    return res
  },
  async createJumpSpaceHandler({getters, dispatch}, data) { //creates a room which is a link to a different space(area)
    let res = await dispatch('api/nav/createSpacePortal', [getters.getCurrentAreaId, data]);
    if(res.success) { //area update
      let success = res.success

      dispatch('calcAuthorisedLocations', success)
      dispatch('updateLocation', [success])
      dispatch('analytics/createPortal', data)
    } else {
      dispatch('popups/nav/errorCreatingJumpSpace')
    }
    return res
  },
};

export default {
  actions
};
